export default "__VITE_ASSET__B1iU9vA4__"